import NPCRoom from '../components/play_with_robot/NPCRoom';

function PlayWithRobotPage() {

    return (
        <NPCRoom />
    )
};

export default PlayWithRobotPage;